export const INITIAL_PAGINATION = {
    lastPage: 1,
    page: 1,
    sort: 'id',
    order: 1
}